import { render, staticRenderFns } from "./productDelCenTwo.vue?vue&type=template&id=64faf551&scoped=true"
import script from "./productDelCenTwo.vue?vue&type=script&lang=js"
export * from "./productDelCenTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64faf551",
  null
  
)

export default component.exports